(function() { window.GUID_5c0ab186_13a6_4068_8e53_e5e3518cb462 = { getGuid: function() { return "5c0ab186-13a6-4068-8e53-e5e3518cb462"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: 'body',
                        childSelector: '.accordion-followers',
                        callback: function (control, e) {
                            control.$Container.offon('click.remove-follower', '.remove-follower', function () {
                                let pid = $(this).data('followerid');
                                let data = {
                                    followerid: pid
                                };
                                CS.Ajax.Post(CS.Url.CSUrl("friendblockfollower"), data, (response) => {
                                    control.RefreshContent();
                                });
                            });
                            control.$Container.offon('click.unblock-follower', '.unblock-follower', function () {
                                let pid = $(this).data('followerid');
                                let data = {
                                    followerid: pid
                                };
                                CS.Ajax.Post(CS.Url.CSUrl("friendunblockfollower"), data, (response) => {
                                    control.RefreshContent();
                                });
                            });
                        }
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=followers.js.map
